<style lang="scss" scoped>
$slideoutWidth: 400px;

.slideout-container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    pointer-events: none;
    top: 0;
    left: 0;
    z-index: 10000;
    transition: background-color 0.15s;

    .slideout {
        position: absolute;
        display: flex;
        flex-direction: column;
        width: $slideoutWidth;
        left: -$slideoutWidth;
        height: 100%;
        opacity: 0;
        top: 0;
        background: #fff;
        box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.16);
        transition: all 0.15s ease-in-out;
        overflow-y: auto;
        overflow-x: hidden;

        @media screen and (max-width: 767.98px) {
            width: 100%;
            right: -100%;
        }

        .close {
            position: absolute;
            width: 12px;
            height: 12px;
            right: 26px;
            top: 26px;
            cursor: pointer;

            @media screen and (max-width: $slideoutWidth) {
                position: fixed;
            }

            &:before,
            &:after {
                content: "";
                position: absolute;
                width: 14px;
                height: 1px;
                border-radius: 1px;
                left: 0;
                transform-origin: left;
                transition: background 0.15s ease-in-out;
                background-color: #000;
            }

            &:before {
                top: 1px;
                transform: rotate(45deg);
            }

            &:after {
                bottom: 0;
                transform: rotate(-45deg);
            }

            &:hover {
                &:before,
                &:after {
                    background-color: #000;
                }
            }
        }

        .slideout-content {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
        }

        &.inverse {
            left: unset;
            right: -$slideoutWidth;
        }
    }
}

body.slideout-active {
    .slideout-container.show {
        pointer-events: all;
        background-color: rgba(27, 28, 31, 0.24);

        .slideout {
            left: 0;
            opacity: 1;

            &.inverse {
                left: unset;
                right: 0;
                opacity: 1;
            }
        }
    }
}

.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity 0.2s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

<template>
    <div class="slideout-container" @click="toggleSlideout" :class="{show: show}">
        <div class="slideout" :class="{inverse: inverse}" @click.stop>
            <div class="close" @click="toggleSlideout"></div>
            <div class="slideout-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from '@/app';

export default {
    name: 'Ui.SlideoutContainer',

    props: {
        name: {
            type: String,
            required: true
        },

        inverse: {
            type: Boolean,
            required: false,
            default: false
        },
    },

    data() {
        return {
            show: false,
            state: {
                title: "",
                progress: 0,
            }
        };
    },

    created() {
        const self = this;

        this.updateTitle(this.title);

        bus.$on('slideout', (name) => {
            if (self.name === name) {
                self.show = true;
            }
        });

        bus.$on('slideout-close', () => {
            this.toggleSlideout();
        });

        this.$on('progress', (value) => {
            self.updateProgress(value);
        });

        this.$on('title', (value) => {
            self.updateTitle(value);
        });

        this.$on('close', (value) => {
            self.toggleSlideout();
        });
    },

    methods: {
        toggleSlideout() {
            this.$root.slideoutIsOpen = !this.$root.slideoutIsOpen;
            this.show = false;

            window.setTimeout(() => {
                bus.$emit('shopping-basket-message', '');
            }, 300);
        },

        updateProgress(progress) {
            this.state.progress = progress;
        },

        updateTitle(title) {
            this.state.title = title;
        }
    },

    computed: {
        titleState() {
            return this.state.title;
        },

        progressState() {
            return this.state.progress;
        }
    },

    watch: {
        show() {
            document.getElementsByTagName('body')[0].classList.toggle("slideout-active");
        }
    }
}
</script>